// @file 指标相关常量文件

export const run_status_map = {
  0: '等待运行',
  1: '进行中',
  2: '任务取消',
  3: '任务成功',
  4: '任务失败',
  5: '进行中'
}